
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 13","fill":"#FAFF1B","stroke":"#FFCD1C","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.08 1.145c.347-.808 1.493-.808 1.84 0l.92 2.149a1 1 0 00.92.606h2.105a1 1 0 01.768 1.64L10.84 7.694a1 1 0 00-.194.915l.58 2.03c.247.862-.679 1.587-1.457 1.143l-2.272-1.299a1 1 0 00-.992 0l-2.272 1.298c-.778.445-1.704-.28-1.457-1.143l.58-2.03a1 1 0 00-.194-.914L1.367 5.54a1 1 0 01.768-1.64h2.106a1 1 0 00.919-.606l.92-2.15z","fill":"inherit","stroke":"inherit","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    